export const SingleBlog = () => {
    return (
        <div>
            <h1>This is where you view one blog and can edit or delete.</h1>
        </div>
    );
};